import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Giriş yapılamadı");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <h1 className="font-blackletter text-5xl text-[#EDEDEA] text-center">CELLAT<span className="text-[#8B0000]">36</span></h1>
        <p className="text-center text-xs tracking-[0.4em] text-[#525252] uppercase mt-2 mb-10">Yönetim Paneli</p>
        <form onSubmit={submit} className="border border-[#232323] bg-[#111111] p-8 space-y-4">
          <input
            data-testid="admin-email-input"
            type="email"
            className="field-dark"
            placeholder="E-posta"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          <input
            data-testid="admin-password-input"
            type="password"
            className="field-dark"
            placeholder="Şifre"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          {error && <p data-testid="admin-login-error" className="text-[#C1121F] text-sm">{error}</p>}
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-[#8B0000] hover:bg-[#C1121F] text-[#EDEDEA] py-3.5 text-sm tracking-[0.25em] uppercase font-semibold transition-colors disabled:opacity-50"
          >
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
      </div>
    </div>
  );
}
